/**
 * „Treffer antippen → ganze Mail“ — die Wörter zwischen Server und Seite. (20.10.2026, Martin per Knopf-Ja 19:57, Punkt 2)
 *
 * Albert kann oft nicht hören und liest. In der Trefferliste der Mail-Suche trägt darum jeder Treffer einen Knopf „Lesen“: die Seite
 * holt die ganze Mail über MAIL_LESEN_PFAD (server/mail-lesen-route.ts) — OHNE Vespera, ohne Modell, ohne Zug. Nur lesend, nur das
 * Postfach des angemeldeten Kontos (Konto aus der Sitzung, nie aus dem Körper), nur `{ id }` im Körper.
 * Diese Datei hat keine Node-Abhängigkeit (die Seite importiert sie).
 */

export const MAIL_LESEN_PFAD = "/api/mail/lesen";
/** Der Kopf der eigenen Seite (server/eigene-seite.ts, Kopf `x-vespera-aktion`) mit eigenem Wert. */
export const MAIL_LESEN_KOPF_WERT = "mail-lesen";
/** Höchstens so viele Abrufe je Konto und Stunde — jeder Versuch zählt. */
export const MAIL_LESEN_JE_STUNDE = 60;

/**
 * Eine Gmail-Nachrichtenkennung: Kleinbuchstaben-Hex, 10 bis 24 Zeichen (Gmail vergibt heute 16).
 * Kein Pfadteil, kein Abfrageteil, keine Thread-Syntax — sonst `null`. Rein.
 */
const MAIL_ID_MUSTER = /^[0-9a-f]{10,24}$/;

export function mailIdAus(wert: unknown): string | null {
  return typeof wert === "string" && MAIL_ID_MUSTER.test(wert) ? wert : null;
}

/** Feste Fehlergründe der Route — die Seite übersetzt sie in Worte (nie Text vom Server anzeigen). */
export const MAIL_LESEN_FEHLER = [
  "aus",
  "not-logged-in",
  "auth-revoked",
  "herkunft-unzulaessig",
  "ungueltig",
  "limit",
  "nicht-verbunden",
  "nicht-gefunden",
  "nicht-bereit",
] as const;
export type MailLesenFehlerCode = (typeof MAIL_LESEN_FEHLER)[number];
